import React, { useState } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import RadioQuestion from "../../components/RadioQuestion";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";

const NUMBER_OF_GIFTS_OPTIONS = [
  { title: "1", value: 1 },
  { title: "2", value: 2 },
  { title: "3", value: 3 },
  { title: "4", value: 4 },
];

const GiftingMoney = ({ giftingMoney, onStepComplete }) => {
  const [formState, setFormState] = useState({
    numberOfSource: giftingMoney?.numberOfSource ?? null,
  });
  const [errors, setErrors] = useState({});
  const [errorMessages] = useState({
    numberOfSource: "Please choose an option",
  });

  const handleInputChange = (field) => (value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleValidation = () => {
    let newErrors = {};
    let formIsValid = true;

    if (formState.numberOfSource === null) {
      newErrors.numberOfSource = true;
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleRadioValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    setErrors((prev) => {
      let newErrors = { ...prev };

      if (!isBlur) {
        newErrors[field] = false;
      } else {
        if (formState[field] === null) {
          newErrors[field] = true;
        }
      }

      return newErrors;
    });
  };

  const saveGiftingMoney = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        giftingMoney: {
          numberOfSource: formState.numberOfSource,
        },
      });
    }
  };

  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="Tell us about any gifts of money from someone who is alive" removeTopPadding>
        <p>
          A gift of money is when someone gives you money that you don't have to pay back. This could be a gift from a
          family member or friend.
        </p>
        <p>
          We need to know how many gifts you are receiving and how much money you are receiving in total towards your
          purchase.
        </p>
        <p>
          If you're buying with another person, and both receiving a gift from the same person, this counts as one gift.
          If the gift is from a joint account - this also counts as one gift.
        </p>

        <RadioQuestion
          question="How many gifts are you receiving?"
          options={NUMBER_OF_GIFTS_OPTIONS}
          inline={false}
          name="numberOfSource"
          selected={formState.numberOfSource}
          optionSelected={handleInputChange("numberOfSource")}
          validate={handleRadioValidation("numberOfSource")}
          validationError={errors.numberOfSource ? errorMessages.numberOfSource : null}
        />

        <Action onClick={saveGiftingMoney}>Continue</Action>
      </Card>

      <Image src={imageCatAndHousePlant} />
    </React.Fragment>
  );
};

export default GiftingMoney;
